import { apiConnector } from "./apiconnector";
const API_URL= process.env.REACT_APP_API_URL;
// Plant Management APIs
export const getPlants = async (params = {}) => {
  try {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined) searchParams.append(key, params[key]);
    });
    
    const response = await apiConnector('GET', `${API_URL}/plants?${searchParams}`);

    return response;
  } catch (error) {
    console.error('Error fetching plants:', error);
    throw error;
  }
};

export const getPlantById = async (id) => {
  try {
    const response = await apiConnector('GET', `${API_URL}/plants/${id}`);
    return response;
  } catch (error) {
    console.error('Error fetching plant by ID:', error);
    throw error;
  }
};

export const createPlant = async (plantData) => {
  try {
    const response = await apiConnector('POST', `${API_URL}/plants`, plantData);
    return response;
  } catch (error) {
    console.error('Error creating plant:', error);
    throw error;
  }
};

export const updatePlant = async (id, plantData) => {
  try {
    const response = await apiConnector('PUT', `${API_URL}/plants/${id}`, plantData);
    return response;
  } catch (error) {
    console.error('Error updating plant:', error);
    throw error;
  }
};

export const deletePlant = async (id) => {
  try {
    const response = await apiConnector('DELETE', `${API_URL}/plants/${id}`);
    return response;
  } catch (error) {
    console.error('Error deleting plant:', error);
    throw error;
  }
};

export const getPlantDashboard = async (id, params = {}) => {
  try {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key]) searchParams.append(key, params[key]);
    });
    
    const response = await apiConnector('GET', `${API_URL}/plants/${id}/dashboard?${searchParams}`);
    return response;
  } catch (error) {
    console.error('Error fetching plant dashboard:', error);
    throw error;
  }
};

export const getAvailableAdmins = async () => {
  try {
    const response = await apiConnector('GET', `${API_URL}/plants/available-admins`);
    return response;
  } catch (error) {
    console.error('Error fetching available admins:', error);
    throw error;
  }
};